/// <reference path="./SimpleItemList.ts" />
namespace HA.Core.HTML.TBox {
    export class ItemList extends SimpleItemList {

        protected createItem(data: string) {
            return new ListItem(data);
        }

    }
}
